(function () {
    'use strict';

    angular.module('app.basicPages.agreeTerms', [
        'app.core',
        'app.access'
    ]);
})();